import { render, staticRenderFns } from "./PendingProformaItem.vue?vue&type=template&id=18796d36&scoped=true&lang=pug&"
import script from "./PendingProformaItem.vue?vue&type=script&lang=js&"
export * from "./PendingProformaItem.vue?vue&type=script&lang=js&"
import style0 from "./PendingProformaItem.vue?vue&type=style&index=0&id=18796d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18796d36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
